/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

export const componentDictionary = {};

componentDictionary['__local__|__local__|components|addtocart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-addtocart' */
                'partner/components/addtocart.component.tsx'),
            cn: '__local__-__local__-addtocart'
        };
componentDictionary['__local__|__local__|components|cartlineitem-variant'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cartlineitem-variant' */
                'partner/components/cartlineitem-variant.component.tsx'),
            cn: '__local__-__local__-cartlineitem-variant'
        };
componentDictionary['__local__|__local__|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cartlineitem' */
                'partner/components/cartlineitem.component.tsx'),
            cn: '__local__-__local__-cartlineitem'
        };
componentDictionary['__local__|__local__|components|elicit-amountselector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-elicit-amountselector' */
                'partner/components/elicit-amountselector.component.tsx'),
            cn: '__local__-__local__-elicit-amountselector'
        };
componentDictionary['__local__|__local__|components|elicit-cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-elicit-cartlineitem' */
                'partner/components/elicit-cartlineitem.component.tsx'),
            cn: '__local__-__local__-elicit-cartlineitem'
        };
componentDictionary['__local__|__local__|components|product'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product' */
                'partner/components/product.component.tsx'),
            cn: '__local__-__local__-product'
        };
componentDictionary['__local__|__local__|modules|subscriptions-minicart|components|bottle-count-display'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-bottle-count-display' */
                'partner/modules/subscriptions-minicart/components/bottle-count-display.component.tsx'),
            cn: '__local__-__local__-bottle-count-display'
        };
componentDictionary['__local__|__local__|modules|subscriptions-minicart|components|box-edit'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-box-edit' */
                'partner/modules/subscriptions-minicart/components/box-edit.component.tsx'),
            cn: '__local__-__local__-box-edit'
        };
componentDictionary['__local__|__local__|modules|subscriptions-minicart|components|cart-display'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cart-display' */
                'partner/modules/subscriptions-minicart/components/cart-display.component.tsx'),
            cn: '__local__-__local__-cart-display'
        };
componentDictionary['__local__|__local__|modules|subscriptions-minicart|components|subscription-banner-display'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-subscription-banner-display' */
                'partner/modules/subscriptions-minicart/components/subscription-banner-display.component.tsx'),
            cn: '__local__-__local__-subscription-banner-display'
        };
componentDictionary['__local__|__local__|themes|columbiacrest|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/columbiacrest/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['__local__|__local__|themes|enoteca|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/enoteca/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['__local__|__local__|themes|erath|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/erath/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['__local__|__local__|themes|generazioni|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/generazioni/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['__local__|__local__|themes|intrinsic-wine-co|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/intrinsic-wine-co/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['__local__|__local__|themes|north-star|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/north-star/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['__local__|__local__|themes|patzhall|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/patzhall/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['__local__|__local__|themes|spring-valley-vineyard|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/spring-valley-vineyard/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['__local__|__local__|themes|stemichelle-rebrand|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/stemichelle-rebrand/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['__local__|__local__|themes|stemichelle|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/stemichelle/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-cartlineitem' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/cartlineitem.component.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-cartlineitem'
        };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|promocode'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-promocode' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/promocode.component.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-promocode'
        };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-header'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-header' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-header.component.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-header'
        };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-order-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-order-list' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-order-list.component.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-order-list'
        };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-order-table'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-order-table' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-order-table.component.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-order-table'
        };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-organization-wide-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-organization-wide-selector' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-organization-wide-selector.component.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-organization-wide-selector'
        };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-view-mode-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-view-mode-selector' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-view-mode-selector.component.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-view-mode-selector'
        };